import React, { useContext } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { OffCanvas, Icon } from "@mostlycode/ui"
import { darken } from "polished"
import { NavigationContext } from "context"
import { useLockBodyScroll } from "hooks/useLockBodyScroll"

const StyledOffCanvasNavigation = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colors.ice};
  color: ${(props) => props.theme.colors.primary};
  position: relative;
`

const StyledFooter = styled.footer`
  background: ${(props) => darken(0.05, props.theme.colors.primary)};
  padding: 4rem 2rem;
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    text-align: right;
  }

  p {
    margin: 0;
    font-size: 1.4rem;
    line-height: 1.5;
    color: ${(props) => props.theme.colors.plush};
  }

  a {
    font-size: 1.4rem;
    font-weight: normal;
  }
`

const StyledNavToggle = styled.div`
  margin-left: auto;
  margin-top: 1rem;
  margin-right: 2rem;
  z-index: 100;

  svg:last-child {
    margin-right: 0;
  }
`

const StyledNavInner = styled.nav`
  margin-right: 2rem;
  margin-left: auto;
  padding: 4rem 0;
  text-align: right;
`

const StyledLogo = styled.div`
  svg {
    width: 10.05rem;
    height: 6.2rem;
    fill: ${(props) => props.theme.colors.plush};
  }
`

function OffCanvasNav({ navToggle, nav, children }) {
  const toggled = useContext(NavigationContext)
  useLockBodyScroll(toggled)
  return (
    <OffCanvas selector="#___offcanvas" show={toggled} fromRight>
      <StyledOffCanvasNavigation>
        <StyledNavToggle>{navToggle}</StyledNavToggle>
        <StyledNavInner>{nav}</StyledNavInner>
        <StyledFooter>
          <StyledLogo>
            <Icon icon="logo" />
          </StyledLogo>
          <div>{children}</div>
        </StyledFooter>
      </StyledOffCanvasNavigation>
    </OffCanvas>
  )
}

export default OffCanvasNav

OffCanvasNav.defaultProps = {
  children: null,
}

OffCanvasNav.propTypes = {
  navToggle: PropTypes.node.isRequired,
  nav: PropTypes.node.isRequired,
  children: PropTypes.node,
}
